module.exports = require("vuetify/lib/components/VMain");